import { Skeleton } from "@/components/ui/skeleton";

export function PricingSkeleton() {
  return (
    <div className="mx-auto max-w-7xl px-6 py-16">
      <div className="mb-12 flex flex-col items-center gap-4">
        <Skeleton className="h-6 w-40 rounded-full" />
        <Skeleton className="h-10 w-3/4 max-w-2xl" />
        <Skeleton className="h-4 w-2/3 max-w-md" />
      </div>

      <div className="mx-auto mb-10 max-w-4xl rounded-2xl border border-border/40 bg-secondary/20 p-6 sm:p-8">
        <div className="flex items-center gap-4">
          <Skeleton className="h-12 w-12 rounded-xl shrink-0" />
          <div className="flex-1 space-y-2">
            <Skeleton className="h-5 w-32" />
            <Skeleton className="h-3 w-3/4" />
          </div>
          <Skeleton className="hidden sm:block h-11 w-44 rounded-lg" />
        </div>
      </div>

      <div className="mb-10 flex items-center justify-center gap-3">
        <Skeleton className="h-4 w-24" />
        <Skeleton className="h-7 w-12 rounded-full" />
        <Skeleton className="h-4 w-20" />
      </div>

      <div className="grid gap-6 md:grid-cols-3">
        {[1, 2, 3].map((i) => (
          <div key={i} className="rounded-2xl border border-border/60 bg-card p-7">
            <Skeleton className="mb-3 h-11 w-11 rounded-xl" />
            <Skeleton className="mb-2 h-6 w-32" />
            <Skeleton className="mb-5 h-3 w-24" />
            <Skeleton className="mb-2 h-10 w-40" />
            <Skeleton className="mb-6 h-4 w-3/4" />
            <div className="mb-7 space-y-3">
              {[1, 2, 3, 4, 5].map((k) => (
                <div key={k} className="flex items-start gap-2.5">
                  <Skeleton className="h-4 w-4 rounded-sm shrink-0" />
                  <Skeleton className="h-4 flex-1" />
                </div>
              ))}
            </div>
            <Skeleton className="h-11 w-full rounded-lg" />
          </div>
        ))}
      </div>
    </div>
  );
}
